import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PDFViewer from './PDFViewer';
import styles from './Dashboard.module.css';

const MunicipalityAdminDashboard = ({ onNavigateToMap }) => {
  const { user, userRole, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: '' },
    { id: 'reports', label: 'PDF Çıktılar', icon: '' },
    { id: 'analytics', label: 'Analitik', icon: '' },
    { id: 'settings', label: 'Ayarlar', icon: '' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <div>
          <h1>Belediye Yönetici Dashboard</h1>
          <p>Hoş geldiniz, {user?.email || user?.username}</p>
          <p className={styles.roleBadge}>Rol: {userRole}</p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button 
            onClick={logout}
            className={styles.logoutButton}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      <div className={styles.dashboardTabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className={styles.tabIcon}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.dashboardContent}>
        {activeTab === 'overview' && (
          <div className={styles.overviewContainer}>
            <div className={styles.overviewHeader}>
              <h2>Genel Bakış</h2>
              <button 
                onClick={onNavigateToMap}
                className={styles.mapButton}
              >
                <span className={styles.mapButtonIcon}></span>
                Harita Üzerinden Hesaplama Yap
              </button>
            </div>
            <div className={styles.overviewCards}>
              <div className={styles.overviewCard}>
                <h3>Toplam Su Tüketimi</h3>
                <p className={styles.cardValue}>2,450 m³</p>
                <p className={styles.cardLabel}>Bu ay</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Aktif Projeler</h3>
                <p className={styles.cardValue}>12</p>
                <p className={styles.cardLabel}>Devam eden</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Toplam Kullanıcı</h3>
                <p className={styles.cardValue}>48</p>
                <p className={styles.cardLabel}>Aktif</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Raporlar</h3>
                <p className={styles.cardValue}>8</p>
                <p className={styles.cardLabel}>Bu ay</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'reports' && (
          <div className={styles.reportsContainer}>
            <PDFViewer />
          </div>
        )}

        {activeTab === 'analytics' && (
          <div className={styles.analyticsContainer}>
            <div className={styles.analyticsHeader}>
              <h2>Analitik ve Raporlama</h2>
              <p className={styles.analyticsSubtitle}>Su tüketimi ve performans metrikleri</p>
            </div>
            
            <div className={styles.analyticsGrid}>
              <div className={styles.analyticsCard}>
                <h3>Aylık Tüketim Trendi</h3>
                <div className={styles.chartPlaceholder}>
                  <p>Grafik yakında eklenecek</p>
                  <div className={styles.chartMock}>
                    <div className={styles.bar} style={{ height: '60%' }}></div>
                    <div className={styles.bar} style={{ height: '75%' }}></div>
                    <div className={styles.bar} style={{ height: '80%' }}></div>
                    <div className={styles.bar} style={{ height: '65%' }}></div>
                    <div className={styles.bar} style={{ height: '90%' }}></div>
                  </div>
                </div>
              </div>
              
              <div className={styles.analyticsCard}>
                <h3>Bölge Bazlı Tüketim</h3>
                <div className={styles.listPlaceholder}>
                  <div className={styles.listItem}>
                    <span>Merkez Bölge</span>
                    <span className={styles.value}>850 m³</span>
                  </div>
                  <div className={styles.listItem}>
                    <span>Kuzey Bölge</span>
                    <span className={styles.value}>620 m³</span>
                  </div>
                  <div className={styles.listItem}>
                    <span>Güney Bölge</span>
                    <span className={styles.value}>480 m³</span>
                  </div>
                  <div className={styles.listItem}>
                    <span>Doğu Bölge</span>
                    <span className={styles.value}>500 m³</span>
                  </div>
                </div>
              </div>
              
              <div className={styles.analyticsCard}>
                <h3>Performans Metrikleri</h3>
                <div className={styles.metricsList}>
                  <div className={styles.metricItem}>
                    <span>Ortalama Tüketim</span>
                    <span className={styles.metricValue}>81.7 m³/gün</span>
                  </div>
                  <div className={styles.metricItem}>
                    <span>En Yüksek Tüketim</span>
                    <span className={styles.metricValue}>125 m³</span>
                  </div>
                  <div className={styles.metricItem}>
                    <span>En Düşük Tüketim</span>
                    <span className={styles.metricValue}>45 m³</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'settings' && (
          <div className={styles.settingsContainer}>
            <div className={styles.settingsHeader}>
              <h2>Belediye Ayarları</h2>
              <p className={styles.settingsSubtitle}>Belediye yapılandırma ve tercihleri</p>
            </div>
            
            <div className={styles.settingsGrid}>
              <div className={styles.settingCard}>
                <div className={styles.settingIcon}></div>
                <h3>Belediye Bilgileri</h3>
                <p>Belediye adı, adres ve iletişim bilgileri</p>
                <button className={styles.settingButton}>Düzenle</button>
              </div>
              
              <div className={styles.settingCard}>
                <div className={styles.settingIcon}></div>
                <h3>Bildirim Ayarları</h3>
                <p>E-posta ve SMS bildirim tercihleri</p>
                <button className={styles.settingButton}>Yapılandır</button>
              </div>
              
              <div className={styles.settingCard}>
                <div className={styles.settingIcon}></div>
                <h3>Raporlama Ayarları</h3>
                <p>Otomatik rapor oluşturma ve gönderim</p>
                <button className={styles.settingButton}>Yapılandır</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MunicipalityAdminDashboard;

